import {FORM_DIRECTIVES, REACTIVE_FORM_DIRECTIVES, FORM_PROVIDERS, FormGroup, FormControl} from "@angular/forms";
import {AlertComponent, TYPEAHEAD_DIRECTIVES, MODAL_DIRECTIVES, BS_VIEW_PROVIDERS} from "ng2-bootstrap/ng2-bootstrap";
import {Component, OnDestroy, OnInit, Input, Output} from "@angular/core";
import {InfractionType} from "../../domain/infractionType";
import {DEFAULT_ERROR_MESSAGES} from "../../validators/validators";
import {InfractionTypeService} from "../../service/infractionType.service";
import {ActivatedRoute} from "@angular/router";
import {EventEmitter} from "@angular/router-deprecated/src/facade/async";

/**
 * .
 * Created by jlado on 5/9/16.
 */
@Component({
    selector: 'infractionType-editor',
    template: require('./infractionType.editor.component.html'),
    directives: [
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        TYPEAHEAD_DIRECTIVES,
        MODAL_DIRECTIVES,
    ],
    providers: [
        FORM_PROVIDERS,
        BS_VIEW_PROVIDERS
    ],
})
export class InfractionTypeEditorComponent implements OnInit, OnDestroy {

    @Input() public infractionType:InfractionType;
    @Output() private close = new EventEmitter();

    public errorMessages:any;
    public errorMessage:string;
    public successMessage:string;

    private sub:any;
    public form:FormGroup;

    public infractionTypeId:string;

    public createMode:boolean;
    public loading:boolean;

    constructor(private infractionTypeService:InfractionTypeService,
                private route:ActivatedRoute) {
        this.init();
    }

    private init():void {
        this.errorMessages = DEFAULT_ERROR_MESSAGES;

        this.loading = false;

        this.infractionType = new InfractionType();
    }

    public ngOnInit():any {
        this.createFormGroup();

        this.sub = this.route.params.subscribe(params => {
            let infractionTypeId = params['infractionTypeId'];
            if (infractionTypeId) {
                this.infractionTypeId = infractionTypeId;
                this.createMode = false;
            } else {
                this.infractionTypeId = null;
                this.createMode = true;
            }
            this.getData();
        });
    }

    public ngOnDestroy():any {
        this.sub.unsubscribe();
    }

    private createFormGroup():void {
        let group:any = {};
        group['name'] = new FormControl(this.infractionType.name);
        /* Validators.required*/
        group['description'] = new FormControl(this.infractionType.description);

        this.form = new FormGroup(group);
    }

    private getData():void {
        if (this.infractionTypeId) {
            this.loading = true;
            this.infractionTypeService.getInfractionType(this.infractionTypeId).subscribe(
                (data) => {
                    this.setData(data);
                },
                () => {
                    this.bindError('Ocurrió un error al obtener los datos del tipo de infracción.');
                });
        }
    }

    private setData(data:any):void {
        this.loading = false;

        if (this.infractionTypeId) {
            this.infractionType = data;
        } else {
            this.infractionType = new InfractionType();
        }
    }

    public save():void {
        this.clearMessages();
        this.loading = true;

        this.infractionTypeService.save(this.infractionType).subscribe(
            (saved:InfractionType) => {
                this.loading = false;
                this.infractionType = saved;
                this.successMessage = 'El tipo de infracción se guardó con éxito';
                this.updateViewAfterSave();
            },
            () => {
                this.bindError('Ocurrió un error al guardar los datos del tipo de infracción.');
            });
    }

    private clearMessages():void {
        this.successMessage = null;
        this.errorMessage = null;
    }

    private updateViewAfterSave():void {
        if (this.createMode) {
            this.infractionType = new InfractionType();
        }
    }

    public goBack(event:any):void {
        event.preventDefault();
        this.close.emit(this.infractionType);
        window.history.back();
    }

    private bindError(messageError:string):void {
        this.loading = false;
        if (this.errorMessage == null) {
            this.errorMessage = messageError;
        } else {
            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/config/infractionTypes/infractionType.editor.component.ts
 **/